export default __webpack_public_path__ + "static/media/black-4.8e57c85f.png";